import * as React from 'react';
import Button from '@mui/material/Button';
import * as Actions from '../../../redux/actions';
import { connect } from 'react-redux';
import { compose, bindActionCreators } from 'redux';
import {getActives} from '../../NewProcess/apiRequestService';
import ShowGrid from '../../ui/ShowGrid'
import DetailPage from './DetailPage';
import styles from '../../../style.js';
import {styleForHeader, styleForAvatar} from '../../../style.js';
import {styleDownloadFileBtn} from '../../ui/ShowGrid/component';

class OnGoing extends React.Component{
  constructor(props){
      super(props);
      this.state = {
          data: [],
          columns : [
            { field: 'id', width: 100, sortable: false,  headerAlign:'center', align:'center',
                renderHeader: () => styleForHeader(''),
                renderCell: (params) => this.styleShowDetailBtn(params.value)
            }, 
            { field: 'name', width: 250, sortable: false, headerAlign:'center', align:'center',
                renderHeader: () => styleForHeader('SÜREÇ ADI')
            },
            { field: 'signOrder', width: 200, sortable: false, headerAlign:'center', align:'center',
                renderHeader: () => styleForHeader('İMZALAMA SIRASI')
            },
            { field: 'sufficientSigner', width: 150, sortable: false, headerAlign:'center', align:'center',
                renderHeader: () => styleForHeader('İMZACI SAYISI')
            },         
            { field: 'status', width: 150, sortable: false, headerAlign:'center', align:'center',
                renderHeader: () => styleForHeader('DURUM')
            },
            { field: 'createdDate', width: 200, sortable: false, headerAlign:'center', align:'center',
                renderHeader: () => styleForHeader('TARİH')
            },    
            { field: 'participant', width: 200, sortable: false, headerAlign:'center', align:'center',
                renderHeader: () => styleForHeader('KATILIMCI'),
                renderCell: (params) => styleForAvatar(params.row.signerInfo)
            },     
            { field: 'downloadFile', width: 200, sortable: false,  headerAlign:'center', align:'center',
            renderHeader: () => styleForHeader(''),
            renderCell: (params) => styleDownloadFileBtn(params.row.id, params.row.status)
            }            
             
        ],
          selectedIds:[],
          editPage: false,
          selectedId:0,
          isLoaded:false
        }
  }


  styleShowDetailBtn = (value) => {
    const onClick = (e) => {
      e.stopPropagation();

      this.SelectRow(value);
    };

    return <Button onClick={onClick} style={styles.showButton} variant="contained" > Göster</Button>   
  }

  showGridRowClick = (params) => {
    this.SelectRow(params.row.id);
  };

  SelectRow(value){
    this.setState({editPage:true,selectedId:value});
  }

  refreshList(){
    getActives()
    .then((response) => {
      this.setState({ data: response.data});
    })
    .catch((exception) => {
      this.props.actions.setNotification("Onay bilgileri getirilemedi daha sonra tekrar deneyin.", 'error');
      console.log('getWaitings exception: ' + JSON.stringify(exception));
    })
    .finally(()=>{
      this.setState({ isLoaded: true});
    });
    
  }

  componentDidMount() {   
    this.refreshList();
  }


  closeEditPage = () => {
    this.setState({ 
      editPage: false});

      this.refreshList();
  };

  render(){
      const {data,columns,editPage,isLoaded} = this.state;
      
      return (
        <div>
          <div>
            {!editPage && isLoaded ?<ShowGrid data={data} columns={columns} handleRowClick={this.showGridRowClick}/>:null}
          </div>
          <div>
            {editPage ? <DetailPage open = {editPage}
            {...this.props} {...this.state} closeEditPage={this.closeEditPage}/> :null}
          </div>
        </div>
        
      );
  }
}

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(Actions, dispatch)
});

export default compose(
  connect(
    null,
    mapDispatchToProps
  ),
)(OnGoing);